import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const title: SxStyle = {
  fontSize: (p) => p.typography.body2.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
};

export const value: SxStyle = {
  fontSize: (p) => p.typography.body2.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
};

export const percent: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightLight,
  color: (p) => p.palette.grey[500],
};
